var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"width":"18px","height":"18px","src":require("@/assets/icon/editer.png"),"alt":"editerIcon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }